<div class="container vh-100 d-flex justify-content-center align-items-center">
  <div class="row align-items-center">
    <div class="col-lg-6 d-none d-lg-block">
      <img
        src="assets/images/cdblack.png"
        alt="Login Image"
        class="img-fluid"
      />
    </div>

    <div class="col-lg-6 col-md-8 col-sm-12 mx-auto">
      <div class="card shadow-lg mycardpadding mb-0">
        <div class="d-lg-none d-block mt-sm-2 mt-0 mylogoimg">
          <img
            src="assets/images/cdblack.png"
            alt="Login Image"
            class="img-fluid"
          />
        </div>
        <div class="card-body">
          <div class="text-center mb-4">
            <h3 class="text-center mb-3 mt-lg-auto mt-3">Sign In</h3>
            <p class="stay-connect">
              To stay connected, log in using your email address
              <i
                class="bi bi-envelope-at-fill"
                style="color: skyblue; font-size: larger"
              ></i>
              and password
              <i
                class="bi bi-key-fill"
                style="color: gold; font-size: larger"
              ></i>
            </p>
          </div>
          <form class="row g-1" #uiForm="ngForm">
            <form-error [form]="form"></form-error>

            <div class="col-12 mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Email</mat-label>
                <input
                  matInput
                  type="email"
                  name="loginId"
                  id="inputEmailAddress"
                  [(ngModel)]="form.data['loginId']"
                  required
                />
                <mat-icon matPrefix class="text-secondary opacity-50"
                  >email</mat-icon
                >
              </mat-form-field>
            </div>

            <div class="col-12">
              <mat-form-field
                appearance="outline"
                class="w-100 d-none-space-bottom"
              >
                <mat-label>Password</mat-label>
                <input
                  matInput
                  [type]="showPassword ? 'text' : 'password'"
                  name="password"
                  id="inputChoosePassword"
                  [(ngModel)]="form.data['password']"
                  required
                />
                <mat-icon matPrefix class="text-secondary opacity-50"
                  >lock_open</mat-icon
                >
                <button
                  type="button"
                  mat-icon-button
                  matSuffix
                  (click)="togglePasswordVisibility()"
                  tabindex="-1"
                >
                  <mat-icon class="text-secondary">{{
                    showPassword ? "visibility" : "visibility_off"
                  }}</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="col-12 d-flex justify-content-end mb-4 mt-2">
              <a
                routerLink="/forgot-password"
                class="text-decoration-none fw-bold"
                style="color: #f84c54"
              >
                Forgot Password?
              </a>
            </div>

            <div class="col-12">
              <button
                mat-raised-button
                color="primary"
                type="submit"
                (click)="login()"
                class="w-100 fat-button shadow-sm"
                [disabled]="!uiForm.valid"
              >
                <span class="fs-6 tracking-wider">Sign In</span>
              </button>
            </div>

            <div class="col-12 text-center mt-4">
              <p class="mb-0 text-muted">
                Don’t have an account?
                <a
                  routerLink="/signup"
                  class="text-decoration-none fw-bold ms-1"
                  style="color: #3f51b5"
                >
                  Sign up here
                </a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>